// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2WgaR","info":"Note_info__2xM7c","note":"Note_note__2dYPK","actions":"Note_actions__98r7V"};